import { render } from "./ChartTest.vue?vue&type=template&id=2f8d5d16"
import script from "./ChartTest.vue?vue&type=script&lang=js"
export * from "./ChartTest.vue?vue&type=script&lang=js"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__